import { slicedToArray as _slicedToArray, objectSpread2 as _objectSpread2, defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useMemo, useEffect } from 'react';
import classNames from 'classnames';
import { Mask } from '../AidMask/mask.js';
import assign from 'lodash/assign';
import assignWith from 'lodash/assignWith';
import isUndefined from 'lodash/isUndefined';
import styles from './AidToast.module.scss.js';
import { PLATFORM, whichPlatform } from '../../utils/ikeaSDK.js';

var defaultProps = {
  maskClickable: false
};
function mergeProps(defaultProps, props) {
  function customize(objValue, srcValue) {
    return isUndefined(srcValue) ? objValue : srcValue;
  }
  return assignWith(assign({}, defaultProps), props, customize);
}
var InternalToast = function InternalToast(p) {
  var props = mergeProps(defaultProps, p);
  var maskClickable = props.maskClickable,
    content = props.content,
    icon = props.icon,
    position = props.position;
  var _useState = useState(PLATFORM.H5),
    _useState2 = _slicedToArray(_useState, 2),
    platform = _useState2[0],
    setPlatform = _useState2[1];
  var iconElement = useMemo(function () {
    if (icon === null || icon === undefined) return null;
    switch (icon) {
      case 'success':
        return /*#__PURE__*/React.createElement("div", null, "success");
      case 'fail':
        return /*#__PURE__*/React.createElement("div", null, "fail");
      default:
        return icon;
    }
  }, [icon]);
  var top = useMemo(function () {
    switch (position) {
      case 'top':
        return '42px';
      case 'bottom':
        return '80%';
      default:
        return '50%';
    }
  }, [position]);
  useEffect(function () {
    whichPlatform().then(function (res) {
      setPlatform(res);
    });
  }, []);
  return /*#__PURE__*/React.createElement(Mask, {
    visible: props.visible,
    destroyOnClose: true,
    opacity: 0,
    getContainer: props.getContainer,
    afterClose: props.afterClose,
    style: _objectSpread2(_objectSpread2({
      pointerEvents: maskClickable ? 'none' : 'all'
    }, props.maskStyle), {}, {
      position: props.getContainer ? 'absolute' : 'fixed'
    }),
    className: classNames(styles.admToastMask, props.maskClassName, platform === PLATFORM.SMP ? styles.smpFix : null)
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      top: top
    },
    className: classNames(styles.admToastWrap, props.contentClassName, icon ? styles.admToastWrapIcon : styles.admToastWrapText, _defineProperty({}, styles.loadingIcon, icon === 'loading'))
  }, iconElement && /*#__PURE__*/React.createElement("div", {
    className: styles.admToastIcon
  }, iconElement), /*#__PURE__*/React.createElement("span", {
    className: styles.text
  }, content)));
};

export { InternalToast, mergeProps };
